import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import { rateCategoryNames } from 'main/rateCategories.js'
import { useContext } from 'react'
import { useSelector } from 'react-redux'

import {
  behaviorNames,
  blackListCategoryNames,
  blackListKeysConversionKeys,
  scopeNames
} from '../../../../../main/blacklistHelpers'
import BlacklistContext from '../../BlackListContext'
import styles from './BehaviorAndScope.module.scss'

const BehaviorAndScope = () => {
  const {
    conversion,
    setScope,
    setBehavior,
    setRateCodeCategory,
    rateCodeCategory,
    exclusions
  } = useContext(BlacklistContext)

  const parentChainCode = useSelector(s => s.hotelDetails.parentChainCode)

  return (
    <>
      {exclusions
        .filter(e => e.requestCategory !== 'rateCodeFull')
        .map(({ requestCategory, behavior, scope }) => (
          <div key={requestCategory} className={styles.col}>
            <div className={styles.title}>
              {conversion[blackListKeysConversionKeys[requestCategory]]}
            </div>
            <div className={styles.subtitle}>
              {blackListCategoryNames[requestCategory]}
            </div>
            <BehaviorDrowndown
              name={requestCategory}
              handleChange={val => setBehavior(requestCategory, val)}
              value={behavior}
            />
            <ScopeDrowndown
              name={requestCategory}
              handleChange={val => setScope(requestCategory, val)}
              value={scope}
            />
          </div>
        ))}
      <div className={styles.col}>
        <div className={styles.title}>
          {conversion[blackListKeysConversionKeys.rateCodeFull]}
        </div>
        <div className={styles.subtitle}>{blackListCategoryNames.rateCodeFull}</div>
        {exclusions
          .filter(e => e.requestCategory === 'rateCodeFull')
          .map(({ requestCategory, behavior, scope }) => (
            <div key={requestCategory}>
              <BehaviorDrowndown
                name={requestCategory}
                handleChange={val => setBehavior(requestCategory, val)}
                value={behavior}
              />
              <ScopeDrowndown
                name={requestCategory}
                handleChange={val => setScope(requestCategory, val)}
                value={scope}
              />{' '}
            </div>
          ))}
        {!conversion.convertedRateCodeKind && (
          <div>
            <p className={styles.multiSelectTitle}>
              What’s the category of this rate code?
            </p>
            <Dropdown
              disabled={parentChainCode === 'independent'}
              defaultVal={
                parentChainCode === 'independent'
                  ? 'Not supported for independent hotels'
                  : 'Select category'
              }
              options={rateCategoryNames}
              value={rateCodeCategory}
              onChange={e => setRateCodeCategory(e.target.value)}
            />
          </div>
        )}
      </div>
    </>
  )
}

const BehaviorDrowndown = ({ handleChange, name, value = 'none' }) => {
  let behaviors = { ...behaviorNames, noExclusion: "Don't charge once" }

  if (name === 'convertedAddress' || name === 'invitedAddress') {
    delete behaviors.noReach
  }

  return (
    <div>
      <p className={styles.multiSelectTitle}>What should we do?</p>
      <div className={styles.multiSelectHolder}>
        {Object.keys(behaviors).map(k => (
          <label className={styles.multiSelectLabel} key={k + name}>
            <input
              type="radio"
              name={k + name}
              onChange={() => handleChange(k)}
              checked={value === k}
            />
            <div className={styles.multiSelectInner}>{behaviors[k]}</div>
          </label>
        ))}
      </div>
    </div>
  )
}

const ScopeDrowndown = ({ handleChange, name, value = 'none' }) => (
  <div>
    <p className={styles.multiSelectTitle}>For what scope?</p>
    <div className={styles.multiSelectHolder}>
      {Object.keys(scopeNames).map(k => (
        <label className={styles.multiSelectLabel} behavior={k + name}>
          <input
            type="radio"
            name={k + name}
            onChange={() => handleChange(k)}
            checked={value === k}
          />
          <div className={styles.multiSelectInner}>{scopeNames[k]}</div>
        </label>
      ))}
    </div>
  </div>
)

export default BehaviorAndScope
